<template>
  <a-modal
    :title="null"
    :visible="showAnyImage"
    dialogClass="demo__AnyImageModal"
    @cancel="closeModal"
    :footer="null"
  >
    <img
      :src="anyImageSrc || '/404Serie.png'"
      @error="
        (e) => {
          e.target.src = '/404Serie.png';
        }
      "
    />
    <i
      class="fa-light fa-xmark-large demo__color--white"
      aria-hidden="true"
      @click="closeModal"
    ></i>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      showAnyImage: false,
      anyImageSrc: undefined,
    };
  },
  beforeDestroy() {
    this.$root.$off("showAnyImageInModal", this.showModal);
  },
  created() {
    this.$accessModule("root_modal", this);
    this.$root.$on("showAnyImageInModal", this.showModal);
  },
  methods: {
    showModal(src) {
      this.anyImageSrc = src;
      this.showAnyImage = true;
    },
    closeModal() {
      this.showAnyImage = false;
      setTimeout(() => {
        this.anyImageSrc = undefined;
      }, 300);
    },
  },
};
</script>
